import { useCallback } from 'react';

import { AxiosError } from 'axios';
import { useAuth } from 'hooks';
import { QueryKeys } from 'queries';
import { useQuery, UseQueryOptions } from 'react-query';

import apiService from 'services/api/ApiService';
import { GetSubscriptionsResponse } from 'services/api/definitions/account.definitions';

export const useSubscriptions = (
  options: UseQueryOptions<GetSubscriptionsResponse, AxiosError> = { enabled: true },
) => {
  const { isLoggedIn } = useAuth();

  const { data, isLoading } = useQuery(
    QueryKeys.subscriptions.all(),
    () => apiService.getSubscriptions(),
    {
      ...options,
      enabled: isLoggedIn && options.enabled,
    },
  );

  const isSubscribedTo = useCallback(
    (shortCode: string) => {
      if (data) {
        return !!data.subscriptions.find(s => s.shortCode === shortCode);
      }
    },
    [data],
  );

  return {
    isLoading,
    isSubscribedTo,
    subscriptions: data,
  };
};
